import { disconnect } from '@giantmachines/redux-websocket';

import { PREFIX } from './constants';

export default () => disconnect(PREFIX);
